// This is needed for the application to run
// eslint-disable-next-line no-unused-vars
import regeneratorRuntime from 'regenerator-runtime';
import 'whatwg-fetch';
import smoothscroll from 'smoothscroll-polyfill';
import './dev';
import './less/index.less';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from './state';
import App from './App';

import { KompisKeyboardInjector } from '@inter-ikea-kompis/react-components';
import { translate } from './services/L10n';
import { t } from './translations';
import { SkapaTheme } from '@inter-ikea-kompis/themes/lib';
import platform from './util/platform';
import { useKioskIntegration } from './hooks/useKioskIntegration';
import 'focus-visible';
import './main.css';

const { isUpptacka } = useKioskIntegration();

smoothscroll.polyfill();

ReactDOM.render(
  <Provider store={store}>
    {platform.isKiosk && !isUpptacka ? (
      <KompisKeyboardInjector
        theme={SkapaTheme}
        doneButtonLabel={translate(t.DONE)}
      >
        <App />
      </KompisKeyboardInjector>
    ) : (
      <App />
    )}
  </Provider>,
  document.getElementById('root')
);
